import {
  FIELD_OPTIONS_REGISTRY,
  type FieldOption,
} from '../constants/field-options-registry.constant';
import { resolveGrantFields } from '../resolvers/resolve-grant-fields';
import { isGrantContext, type TemplateFieldContext } from '../types/template-field-context.types';

export const resolveFieldOptions = (context: null | TemplateFieldContext): FieldOption[] => {
  if (!context) return [];

  const entry = FIELD_OPTIONS_REGISTRY[context.category]?.[context.subCategory];
  if (!entry) return [];

  if (isGrantContext(context)) {
    return resolveGrantFields(entry, context);
  }
  return [...entry.base];
};
